// extracted by mini-css-extract-plugin
module.exports = {"headline":"EABDHomeScreen_headline__1w1x1","content":"EABDHomeScreen_content__2tN1A","line":"EABDHomeScreen_line__1-emE"};